import BlobImage from "../../../components/BlobImage/BlobImage";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import banner from "../../../assets/images/banner.jpg";
import "./Index.css";

const HallOfFameCard = ({ title, name, description, image, isActive }) => {
  return (
    <div
      className={`hof-card ${isActive ? "active" : "hidden"}`}
      style={{
        maxWidth: "100%",
        minHeight: "420px",
        borderRadius: "12px",
        overflow: "hidden",
        background: "#fff",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
        fontFamily: "var(--font-family-primary, 'Open Sans', sans-serif)",
        position: "relative",
      }}
    >
      {/* Banner Background */}
      <div
        style={{
          width: "100%",
          height: "180px",
          overflow: "hidden",
        }}
      >
        <img
          src={banner}
          alt="banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </div>

      {/* Circular Profile Image overlapping banner */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "-60px",
          position: "relative",
          zIndex: 2,
        }}
      >
        <div
          style={{
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            border: "5px solid #fff",
            background: "#fff",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {image ? (
            <BlobImage
              path={image}
              alt={name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          ) : (
            <span style={{ fontSize: "40px" }}>🎉</span>
          )}
        </div>
      </div>

      {/* Content */}
      <div style={{ textAlign: "center", padding: "16px 20px 24px" }}>
        <div
          style={{
            color: "var(--color-blue, #303f9f)",
            fontWeight: 600,
            fontSize: "1.25rem",
            marginBottom: "4px",
          }}
        >
          {title}
        </div>
        {name && (
          <h2
            style={{
              margin: "0 0 12px",
              color: "var(--text-dark, #333)",
              fontSize: "1.1rem",
              fontWeight: 700,
            }}
          >
            {name}
          </h2>
        )}
        <p
          style={{
            color: "var(--text-light, #666)",
            fontSize: "0.9rem",
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default function HallOfFrame(props) {
  const { translations } = useSelector((state) => state.language);
  const t = useMemo(() => translations?.labels || {}, [translations]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!props.hallOfFameData || props.hallOfFameData.length <= 1) return;
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === props.hallOfFameData.length - 1 ? 0 : prevIndex + 1,
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [props.hallOfFameData?.length]);

  if (!props.hallOfFameData || props.hallOfFameData.length === 0) {
    return (
      <div style={{ minHeight: "420px" }}>
        <HallOfFameCard
          title={t.hallOfFame || "Hall Of Fame"}
          name=""
          description={props.description}
          image=""
          isActive={true}
        />
      </div>
    );
  }

  return (
    <div style={{ minHeight: "420px" }}>
      {props.hallOfFameData.map((item, index) => (
        <HallOfFameCard
          key={item.id}
          title={t.hallOfFame || "Hall Of Fame"}
          name={item.name}
          description={item.content}
          image={item.image}
          isActive={index === activeIndex}
        />
      ))}
    </div>
  );
}
